<template>
    <div class="board_card pc template2">
        <!--  left part  start -->
        <div class="category">
            <div class="amount">{{ params.data }}</div>
            <!--  left part  end -->
            <!--  right part  start -->
            <div
                v-show="hasRecentSold"
                class="tendency"
                :class="[
                    { up: params.status === 1, down: params.status === -1 },
                    params.class ? params.class : ''
                ]"
            >
                <!--  more than the  0  or   less than  0 -->
                <div
                    class="data_wrap"
                    v-if="
                        (params.status === 1 || params.status === -1) &&
                            !params.dataComing
                    "
                >
                    <span
                        class="iconfont"
                        :class="{
                            'icon-trend-up': params.status > 0,
                            'icon-trend-down': params.status < 0
                        }"
                    ></span>
                    <span class="num">{{ params.changeNum }}</span>
                </div>
                <!--  equal  0 -->
                <div
                    class="no_data"
                    v-else-if="params.status === 0 && !params.dataComing"
                >
                    <span>{{ params.changeNum }}</span>
                </div>
                <!-- 30-60 No property sold  -->
                <div class="no_data" v-else>
                    <span>{{ params.dataComing ? '' : '-' }}</span>
                </div>
            </div>
            <!--  right part  end -->
        </div>
        <div class="name">{{ params.title }}</div>
    </div>
</template>

<script>
export default {
    name: 'board-pc',
    props: {
        params: Object,
        hasRecentSold: Boolean
    }
};
</script>

<style lang="scss">
@import './board.scss';
.board_card.pc.template2 {
    flex: 1 0 0;
    padding: 0 30px;
    position: relative;
    &::after {
        content: '';
        width: 1px;
        height: 70px;
        border-radius: 2px;
        background-color: #e6e6e6;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    &:last-child {
        padding-right: 0;
        &::after {
            display: none;
        }
    }
    &:first-child {
        padding-left: 0;
    }
}
</style>
